import { v4 as uuid } from 'uuid';

const KEY = 'chatdoc_uid';

export const setChatDocUID = () => {
  if (!document.cookie.includes(KEY)) {
    // chrome最大支持一年
    document.cookie = `${KEY}=${uuid()};max-age=${
      60 * 60 * 24 * 365 * 2
    };path=/`;
  }
};
